// src/pages/admin/AdminUsersPage.tsx

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/store/authStore';
import { toast } from 'react-hot-toast';
import AdminAnalyticsComponent from '@/components/admin/AdminAnalyticsComponent';

const AdminAnalyticsPage: React.FC = () => {
    const navigate = useNavigate();
    const { user } = useAuth();

    // Verificar que el usuario sea admin
    React.useEffect(() => {
        if (user?.user_type !== 'admin') {
            toast.error('No tienes permisos para acceder a esta página.');
            navigate('/', { replace: true });
        }
    }, [user, navigate]);

    const handleNavigateBack = () => {
        navigate('/admin/dashboard');
    };

    // Si no es admin, no mostrar nada mientras redirige
    if (user?.user_type !== 'admin') {
        return (
            <div className="min-h-screen bg-gray-50 flex items-center justify-center">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
                    <p className="text-gray-600">Verificando permisos...</p>
                </div>
            </div>
        );
    }

    return (
        <AdminAnalyticsComponent onNavigateBack={handleNavigateBack} />
    );
};

export default AdminAnalyticsPage;

// ===========================================
